<script>
import {mapGetters} from 'vuex';
import PlpProductsList from '@/components/containers/plp/PlpProductsList';

export default {
  components: {PlpProductsList},

  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },
};
</script>
